import { useState } from 'react';
import { Image, Text } from '@belong/ui';
import { SignerCurrentData } from 'pages/Accounts/Pages/ToursAndApps/SignatureStatusUtils';

type Props = {
  signers: SignerCurrentData[];
};

function getSignerLabelAndColor(
  // Optional because it is optional on the signer, and the `default` branch
  // below already covers every value that is not `Signed`.
  status?: 'Signed' | 'Pending' | 'Declined',
) {
  switch (status) {
    case 'Signed':
      return { label: 'Signed', color: 'green' };
    default:
      return { label: 'Pending', color: 'orange' };
  }
}

const Signer = ({ signer }: { signer: SignerCurrentData }) => {
  const [hasError, setHasError] = useState(false);

  const { label, color } = getSignerLabelAndColor(signer.signatureStatus);

  return (
    <div className="flex flex-row gap-sm">
      <div
        className="relative overflow-hidden rounded-full bg-green"
        style={{ width: 50, height: 50 }}
      >
        {!hasError && signer?.imageUrl && (
          <Image
            src={signer.imageUrl}
            alt=""
            className="object-cover"
            onError={() => setHasError(true)}
          />
        )}
        {(hasError || !signer?.imageUrl) && (
          <Image src="/icons/profile_img.svg" alt="" className="object-cover" />
        )}
      </div>
      <div className="flex min-w-0  flex-col">
        <Text className="text-p3 w-[55vw] truncate font-semibold md:w-[195px]">
          {signer.isCurrentUser ? 'You' : signer.fullName}
        </Text>
        <Text className={`text- text-p1 font-semibold${color}`}>{label}</Text>
      </div>
    </div>
  );
};

const ApplicationSignerList = ({ signers }: Props) => {
  return (
    <div className="grid w-full grid-cols-1 gap-sm pt-sm md:grid-cols-2 xl:grid-cols-3">
      {signers.map((signer, index) => (
        <Signer key={index} signer={signer} />
      ))}
    </div>
  );
};

export default ApplicationSignerList;
